import { render, staticRenderFns } from "./exchange-goods-popup.vue?vue&type=template&id=32484f98&scoped=true&lang=pug&"
import script from "./exchange-goods-popup.vue?vue&type=script&lang=js&"
export * from "./exchange-goods-popup.vue?vue&type=script&lang=js&"
import style0 from "./exchange-goods-popup.vue?vue&type=style&index=0&id=32484f98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32484f98",
  null
  
)

export default component.exports